import * as React from "react";
import { cn } from "../../lib/utils";

export enum FilterCardType {
	FOREST = "forest",
	ORANGE = "orange",
	GREEN = "green",
	GRAY = "gray",
}

export interface FilterCardProps {
	title: string;
	counter: bigint | number | string;
	type: FilterCardType;
	onClick?: () => void;
	isActive?: boolean;
}

const themeConfig = {
	[FilterCardType.FOREST]: {
		activeBorder: "border-forest-600",
		border: "border-forest-100",
		background: "bg-forest-100",
		text: "text-forest-600",
	},
	[FilterCardType.ORANGE]: {
		activeBorder: "border-orange-600",
		border: "border-orange-50",
		background: "bg-orange-50",
		text: "text-orange-600",
	},
	[FilterCardType.GREEN]: {
		activeBorder: "border-green-600",
		border: "border-green-50",
		background: "bg-green-50",
		text: "text-green-600",
	},
	[FilterCardType.GRAY]: {
		activeBorder: "border-gray-600",
		border: "border-gray-50",
		background: "bg-gray-50",
		text: "text-gray-600",
	},
};

const formatNumber = (value: bigint | number | string): string => {
	if (typeof value === "bigint" || typeof value === "number") {
		return value.toLocaleString();
	}
	return value.toString();
};

const FilterCard = React.forwardRef<HTMLButtonElement, FilterCardProps>(
	(
		{ title, counter, type, onClick = () => {}, isActive = false, ...props },
		ref,
	) => {
		const theme = themeConfig[type];

		return (
			<button
				ref={ref}
				className={cn(
					"flex flex-col items-start justify-center py-2 px-4 rounded-lg border transition-all duration-200 min-w-40",
					isActive ? theme.activeBorder : theme.border,
					theme.background,
				)}
				onClick={onClick}
				{...props}
			>
				<div className={cn("text-xs mb-1", theme.text)}>
					{title}
				</div>
				<div className={cn("text-sm font-semibold", theme.text)}>
					{formatNumber(counter)}
				</div>
			</button>
		);
	},
);

FilterCard.displayName = "FilterCard";

export { FilterCard };
